
<template>
  <!--投诉管理-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="complaintId"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :scrollWidth='{ x: 2000 }'
    >
      <template slot="opt_a" slot-scope="{row}">
        <template v-if="row.fileMap&&row.fileMap.length>0">
          <a @click ="showAttachment(row)" >查看</a>
        </template>
      </template>
      <template slot="opt_c" slot-scope="{row}">
        <a-tooltip :title="row.textContent">
          <div class="feed-over-text">{{row.textContent}}</div>
        </a-tooltip>
      </template>
    </x-tabula>
    <!--新增的弹窗-->
    <a-modal
        title="处理投诉"
        :visible="visible"
        @cancel="visible=false"
        @ok="okFun"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="700px"
    >
      <x-addEdit
          ref="addEdit"
          formType="modal"
          :isSubmitBtn="false"
          :itemLayout="$store.state.modal_ItemLayout"
          :reqLoading="btnLoading"
          :formList="formList"
          :formKey="formKey"
      >

      </x-addEdit>
    </a-modal>

    <media ref='media'></media>
  </div>
</template>

<script>
import media from './postManage/mediaBox.vue';

export default {
  name: 'NCcomplain',
  components: {
    media
  },
  data () {
    return {
      complaintId: undefined,
      visible: false,
      btnLoading: {loading: false},
      formList: [
        {
          label: '平台反馈',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入至少5个字',
          handle: this.dataTypeChange,
          disabled: false,
          props: ['remark', {
            rules: [{required: true, min: 5, message: '请输入处理意见,最少5个字符'}]
          }]
        },
        {
          label: '处理方式',
          inputType: 'radioGroup',
          options: [{label: '受理', value: 1}, {label: '驳回', value: 2}],
          placeholder: '',
          handle: (e) => {
          },
          props: ['status', {
            rules: [
              { required: true, message: '请选择处理方式' }
            ],
            initialValue: 1
          }]
        }
      ],
      formKey: {
        type: undefined,
        mapLng: undefined,
        mapLat: undefined
      },
      searchList: [
        { props: ['nickName'], placeholder: '投诉人', inputType: 'input' },
        { props: ['keyWords'], placeholder: '投诉内容、帖子ID', inputType: 'input' },
        {
          props: ['type'],
          placeholder: '帖子类型',
          options: [
          ],
          inputType: 'select'
        },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' },
        { props: ['complaintCategoryIds'], placeholder: '投诉类型', options: [], inputType: 'cascader', changeOnSelect: true },
        { props: ['createDate'], placeholder: ['投诉时间', '投诉时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        nickName: undefined,
        keyWords: undefined,
        type: undefined,
        status: undefined,
        complaintCategoryIds: undefined,
        createDate: undefined
      },
      tableOptList: [],
      rowOptList: [
        {
          text: '处理',
          handle: record => this.handleComplain(record, '处理'),
          rowOptDisHandle: record => this.optBtnDisable(record, '处理'),
          permi: ['community:housekeepCircleComplaint:handle']
        }
      ],
      columns: [
        { title: '投诉ID', dataIndex: 'complaintId', align: 'left', width: '' },
        { title: '投诉人手机号', dataIndex: 'mobilePhone', align: 'left', width: '110px' },
        { title: '投诉人昵称', dataIndex: 'nickName', align: 'left', width: '' },
        { title: '帖子ID', dataIndex: 'circleId', align: 'left', width: '' },
        { title: '内容', dataIndex: 'textContent', align: 'left', width: '250px', scopedSlots: {customRender: 'c'}},
        { title: '类型', dataIndex: 'typeDesc', align: 'left', width: '' },
        { title: '隶属', dataIndex: 'channelName', align: 'left', width: '' },
        { title: '投诉类型', dataIndex: 'title', align: 'left', width: ''},
        { title: '投诉理由', dataIndex: 'content', align: 'left', width: '160px' },
        { title: '投诉附件', dataIndex: 'fileMap', align: 'left', width: '', scopedSlots: {customRender: 'a'} },
        { title: '处理意见', dataIndex: 'remark', align: 'left', width: '160px' },
        { title: '投诉时间', dataIndex: 'createTime', align: 'left', width: '200px' },
        { title: '处理时间', dataIndex: 'handleTime', align: 'left', width: '200px' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', fixed: 'right', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/housekeep/circle/complaint/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    showAttachment (row) {
      this.$refs.media.show(row.fileMap.map(item => item.fileUrl), document.documentElement.scrollTop);
    },
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) { return; }
        this.$put({
          url: '/housekeep/circle/complaint/handle/' + this.complaintId,
          params: {
            ...values
          }
        }).then((res) => {
          this.$message.success(res.msg);
          this.visible = false;
          this.$refs.table.getTableList();
        });
      });
    },
    /* 获取下拉 */
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_housekeep_circle_complaint_type',
        params: {}
      }).then(({data}) => {
        this.searchList[2].options = data;
      });
      this.$get({
        url: '/dict/data/dictType/comu_housekeep_circle_complaint_status',
        params: {}
      }).then(({data}) => {
        this.searchList[3].options = data;
      });

      this.$get({
        url: '/housekeep/complaint/category/treeSelect',
        params: {}
      }).then(({data}) => {
        this.searchList[4].options = data;
      });
    },
    /** 处理table列表 */

    optBtnDisable (record, type) {
      if (type === '处理' && record.status != 0) {
        return true;
      }
    },
    /** 处理投诉 */
    handleComplain (row, type) {
      this.complaintId = row.complaintId;
      this.visible = true;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped>
::v-deep .ant-table-body::-webkit-scrollbar{height:4px;}
::v-deep .ant-table-body::-webkit-scrollbar-track{border-radius:5px;background:rgb(249, 249, 249);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(222, 222, 222);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb:hover{background:rgba(102,102,102,.6);}
::v-deep .ant-table-body::-webkit-scrollbar-thumb:active{background:rgba(102,102,102,.6);}
</style>
